import React, {useEffect, useState} from 'react'
import {Warning} from "../../../components/common/alert/banner";
import {useTranslation} from "react-i18next";
import SearchProduct from "./search-product";
import ProductConfiguration from "./product-configuration";
import {postQuotationProducts} from "../../../api/quotation";
import {useParams} from "react-router-dom";
import {makeid} from "../../../utils/converter";
import SlideResponsivePanel from "../../../components/layout/slide-responsive-panel";

const searchProduct = 'search-product';
const productConfiguration  = 'product-configuration';


const AddCatalog = ({isOpen, setIsOpen, customer, setDetail, containerDetail, quotationDetail, isHideSensitiveData}) => {

    const { t } = useTranslation();
    let { id } = useParams();

    const [step, setStep] = useState(searchProduct);
    const [isBack, setBack] = useState(false);
    const [cachedDetail, setCachedDetail] = useState([]);
    const [exception, setException] = useState(false);
    const [isLoading, setLoading] = useState(false);


    const [selectedProductList, setSelectedProductList] = useState([]);


    useEffect(() => {
        //console.log(selectedProductList);

        // eslint-disable-next-line
    }, [selectedProductList]);

    const clean = () => {
        setStep(searchProduct);
        setSelectedProductList([]);
        setException(false)
    };


    const storeProduct = () => {

        let products = [];
        // eslint-disable-next-line
        selectedProductList.map((item) => {
            let details = {};
            let discounts = (item?.quote_discounts ?? []);
            let final_price = item?.quote_base_price ?? 0;


            details['product'] = {id: item.id} ;
            details['quantity'] = item.quote_quantity;

            details['list_price'] = item.pricing.list_price;
            details['list_discount'] = item.pricing.discount_string;
            details['purchase_price'] = item.pricing.purchase_price;


            details['base_price'] = item.quote_base_price;
            details['discount'] = item.discount_string;

            // eslint-disable-next-line
            discounts.map((discount, index) => {
                final_price = final_price - (final_price * (discount / 100));
            })
            details['discount_price'] = final_price;


            products.push(details);
        });



        if (products.length > 0) {
            setLoading(true);
            setException(false);
            postQuotationProducts({ quotation_id: id, container_id: containerDetail.id,  data: products })
                .then((response) => {
                    setDetail(response);
                    setLoading(false);
                    clean();
                    setIsOpen(false);
                })
                .catch((e) => {
                    setException(e.message);
                    setLoading(false);
                });

        }
    };




    return (
        <SlideResponsivePanel title={t("app.quotations.catalog")}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    size={'max-w-full md:max-w-7xl'}
                    setClean={() => {
                        clean();
                    }}
        >
            <div className="space-y-6 pt-6 pb-5">

                {
                    step === searchProduct && (
                        <SearchProduct
                            selectedProductList={selectedProductList}
                            isBack={isBack}
                            onSelectedProductList={(products) =>{
                                setSelectedProductList([...selectedProductList, ...products]);
                                setBack(false);
                                setStep(productConfiguration);
                            }}
                            cachedDetail={cachedDetail}
                            setCachedDetail={(r) =>{
                                setCachedDetail(r);
                            }}
                            onChangeStep={() =>{
                                setStep(productConfiguration);
                            }}

                        />
                    )
                }


                {
                    step === productConfiguration && (
                        <ProductConfiguration
                            onChangeStep={() => {
                                setBack(true);
                                setStep(searchProduct);
                            }}
                            onSave={() => {
                                storeProduct();
                            }}
                            quotationDetail={quotationDetail}
                            isLoading={isLoading}
                            selectedProductList={selectedProductList}
                            onChangeValue={(id, value, type, isPricing = false) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === id);

                                if(isPricing){
                                    filtered[foundIndex]['pricing'][type] = value
                                }else{
                                    filtered[foundIndex][type] = value
                                }
                                setSelectedProductList(filtered)
                            }}
                            onUpdateProduct={(product) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === product.id);
                                filtered[foundIndex] = product;
                                setSelectedProductList(filtered)

                            }}
                            onAddDiscount={(id) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === id);
                                filtered[foundIndex]['quote_discounts'] = [...filtered[foundIndex]['quote_discounts'], {id: makeid(20), price: null}];
                                setSelectedProductList(filtered)
                            }}
                            onUpdateDiscount={(id, value, index) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === id);
                                filtered[foundIndex]['quote_discounts'][index]['price'] = value !== false ? value : null;
                                filtered[foundIndex]['quote_discounts'] = filtered[foundIndex]['quote_discounts'].filter(r => r.price !== null);
                                setSelectedProductList(filtered);
                            }}
                            onAddDiscountRate={(id) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === id);
                                filtered[foundIndex]['pricing']['discount'] = [...filtered[foundIndex]['pricing']['discount'], {id: makeid(20), price: null}];
                                setSelectedProductList(filtered)
                            }}
                            onUpdateDiscountRate={(id, value, index) => {
                                let filtered = [...selectedProductList];
                                let foundIndex = filtered.findIndex((x) => x.id === id);
                                filtered[foundIndex]['pricing']['discount'][index]['price'] = value !== false ? value : null;
                                filtered[foundIndex]['pricing']['discount'] = filtered[foundIndex]['pricing']['discount'].filter(r => r.price !== null);
                                 setSelectedProductList(filtered);
                            }}
                            onDelete={(id) => {
                                let filtered = [...selectedProductList];

                                // remove internal product
                                filtered = filtered.filter(function( obj ) {
                                    return obj.id !== id;
                                });

                                setSelectedProductList(filtered);
                            }}
                            onSetQuantity={(id, item, value) => {
                                let filtered = [...selectedProductList];

                                let foundIndex = filtered.findIndex((x) => x.id === id);

                                let prodIndex = filtered[foundIndex]['products'].findIndex((x) => x.id === item.id);
                                filtered[foundIndex]['products'][prodIndex]['quantity'] = value

                                setSelectedProductList(filtered)

                            }}
                            isHideSensitiveData={isHideSensitiveData}
                        />
                    )
                }



                {/* Warning */}
                {exception && <Warning message={exception} />}


            </div>
        </SlideResponsivePanel>

    );
};


export default AddCatalog;
